import { useEffect, useState } from 'react';
import CustomFolderTree from './CustomFoldertree';

const BasicTree = ({ FolderData, HandleSelectPerticularFOlder, HandleInsideData }) => {
  const [treeFolder, setTreeFolder] = useState();
  const [activeNodeId, setActiveNodeId] = useState(null);

  // Function to format folders recursively and set `active` based on activeNodeId
  const formatFolder = (folder) => {
    return {
      name: folder?.folderName,
      id: folder?.id,
      active: folder?.id === activeNodeId,
      fullDetails: folder,
      children: folder?.subfolders?.map(formatFolder) || [],
    };
  };

  // Update tree when FolderData or activeNodeId changes
  useEffect(() => {
    if (FolderData) {
      const formattedData = FolderData.map((folder) =>
        folder?.folders?.[0] ? formatFolder(folder.folders[0]) : null,
      ).filter(Boolean);

      setTreeFolder({ name: 'folders', children: formattedData, isOpen: true });
    }
  }, [FolderData, activeNodeId]);
  // Logs state change in the tree (optional)

  return (
    <div>
      <CustomFolderTree
        data={FolderData}
        HandleSelectid={(value) => {
          HandleSelectPerticularFOlder && HandleSelectPerticularFOlder(value);
        }}
        HandleInsideData={HandleInsideData}
      />
    </div>
  );
};

export default BasicTree;
